import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class ClientTimezoneInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const modifiedRequest = request.clone({
      setHeaders: {
        "CST-Client-Timezone": clientTimezone,
      },
    });
    return next.handle(modifiedRequest);
  }
}
